export default "/_next/static/images/bc358ddc42fc34386fcb95a9fb150e61.jpg";